import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  private readonly authService = inject(AuthService);
  username = '';

  ngOnInit(): void {
    this.getUsername();
  }

  getUsername() {
    const claims = this.authService.claims;
    if (!claims) return;
    this.username = `${claims['firstName']} ${claims['lastName']}`;
  }
}
